require('../modules/es6.object.to-string');
require('../modules/web.dom.iterable');
require('../modules/es6.weak-set');
module.exports = require('../modules/_core').WeakSet;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/weak-set.js
// module id = 807
// module chunks = 29